<template>
    <div>
        <template v-if="crud_super_admin == true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Add SuperAdmin</h1>
            </div>
            <div class="global-main">
                <div class="people-management-inner-content">
                    <form id="cityForm" @submit.prevent="addSuperAdmin">
                        <div class="tab-content-inner">
                            <div class="user-permissions">
                                <div class="form-group">
                                    <label> Name </label>
                                    <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                                    <has-error :form="form" field="name"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Mobile No. </label>
                                    <input v-model="form.mobile_no" type="number" name="mobile_no" class="form-control" :class="{ 'is-invalid': form.errors.has('mobile_no') }">
                                    <has-error :form="form" field="mobile_no"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> CNIC </label>
                                    <input v-model="form.cnic" type="number" name="cnic" class="form-control" :class="{ 'is-invalid': form.errors.has('cnic') }">
                                    <has-error :form="form" field="cnic"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> E-Mail Address </label>
                                    <input v-model="form.email" type="email" name="email" class="form-control" :class="{ 'is-invalid': form.errors.has('email') }">
                                    <has-error :form="form" field="email"></has-error>
                                </div>
                                <div class="form-group btn-holder">
                                    <div class="label-holder"> </div>
                                    <button class="btn btn-default" type="button" v-on:click="generatePassword" style="padding:0 20px;">Generate new password</button>
                                </div>                                
                                <div class="form-group">
                                    <label> Password </label>
                                    <input v-model="form.password" type="password" name="password" placeholder="Password must contain Uppercase,Lowercase,Digits,Special characters. Example: 42-aBcdef" id="password" class="form-control" :class="{ 'is-invalid': form.errors.has('password') }">
                                    <i class="far fa-eye" id="togglePassword" @click="togglePassword()"></i>
                                    <has-error :form="form" field="password"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Confirm Password<span class="highlight-color">*</span> </label>
                                    <input v-model="form.password_confirmation" type="password" name="password_confirmation" id="password_confirmation" class="form-control toggleCPassword" :class="{ 'is-invalid': form.errors.has('password_confirmation') }">
                                    <has-error :form="form" field="password_confirmation"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Join Date </label>
                                    <datepicker name="join_date" v-model="form.join_date" input-class="form-control" :class="{ 'is-invalid': form.errors.has('join_date') }"></datepicker>
                                    <has-error :form="form" field="join_date"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Temp User </label>
                                    <select v-model="form.temp_user" name="temp_user" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('temp_user') }" >
                                        <option value="YES">YES</option>
                                        <option value="NO">NO</option>
                                    </select>
                                    <has-error :form="form" field="temp_user"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> City </label>
                                    <select v-model="form.city_id" name="city_id" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('city_id') }" v-if="cities != null">
                                        <option value="" selected>Select City</option>
                                        <option v-for="city in cities" v-bind:value="city.id" v-bind:key="city.id">
                                            {{ city.name }}
                                        </option>
                                    </select>
                                    <has-error :form="form" field="city_id"></has-error>
                                </div>
                                <label class="label block-label"> <span class="highlight-color"> Role </span> </label>
                                <div class="form-group">
                                    <select v-on:change="getPermission($event)" v-model="form.role_id" name="role_id" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('role_id') }" v-if="roles != null" disabled>
                                        <option v-for="role in roles" v-bind:value="role.id" v-bind:key="role.id">
                                            {{ role.name }}
                                        </option>
                                    </select>
                                    <has-error :form="form" field="role_id"></has-error>
                                </div>
                                <select-all-permissions-component :permissions="permissions" :form="form" v-if="permissions"/>
                                <template v-if="permissions != null">
                                    <div class="permissions-box">
                                        <div class="form-group" v-for="(permission, index) in permissions" v-bind:key="permission.id">
                                            <label class="label block-label"> <span class="highlight-color">{{index}}</span> </label>
                                            <div class="permissions-box">
                                                <div class="row">
                                                    <div class="col-md-4 mb-2" v-for="child in permission" v-bind:key="child.id">
                                                        <label class="check-holder ml-0">
                                                            <span class="check-text"> {{child.display_name}} </span> <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="child.description"></i>
                                                            <input type="checkbox" v-bind:value="child.id" v-bind:id="'permission_'+child.id" v-model="form.userPermissions" />
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <div class="page-top mb-1 mb-3 mt-4 clearfix">
                                    <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                                    <router-link to="/superAdmin" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </template>
        <template v-else-if="crud_super_admin === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_super_admin === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    import SelectAllPermissionsComponent from "../../shared/SelectAllPermissionsComponent";
    export default {
        components: {SelectAllPermissionsComponent},
        data() {
            return {
                form: new Form({
                    mobile_no : '',
                    cnic : '',
                    name : '',
                    email : '',
                    password : '',
                    password_confirmation : '',
                    join_date : new Date(),
                    temp_user:'',
                    role_id : '1',
                    userPermissions : []
                }),
                role : {},
                permissions : null,
                cities: null,
                category : null,
                roles: null,
                crud_super_admin: null
            }
        },
        methods: {
            addSuperAdmin() {
                this.$Progress.start();
                this.form.post('api/addSuperAdmin')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: 'Super admin created successfully'
                        });
                        this.$router.push('/superAdmin');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                });
            },
            getAddSuperAdminData(){
                this.$Progress.start();
                axios.get('/api/addSuperAdminData')
                .then(res => {
                    if(res.status == 200){
                        this.roles = res.data.roles;
                        this.cities = res.data.cities;
                        this.permissions = res.data.permissions;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.showAlertBox('error','Some error in your form data');
                });
            },
            generatePassword() {
                var specials = '!$#%@*+^=_-';
                var lowercase = 'abcdefghijklmnopqrstuvwxyz';
                var uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
                var numbers = '0123456789';
                var all = specials + lowercase + uppercase + numbers;

                String.prototype.pick = function(min, max) {
                    var n, chars = '';

                    if (typeof max === 'undefined') {
                        n = min;
                    } else {
                        n = min + Math.floor(Math.random() * (max - min));
                    }

                    for (var i = 0; i < n; i++) {
                        chars += this.charAt(Math.floor(Math.random() * this.length));
                    }

                    return chars;
                };
                String.prototype.shuffle = function() {
                    var array = this.split('');
                    var tmp, current, top = array.length;

                    if (top) while (--top) {
                        current = Math.floor(Math.random() * (top + 1));
                        tmp = array[current];
                        array[current] = array[top];
                        array[top] = tmp;
                    }

                    return array.join('');
                };

                var retVal = (specials.pick(2) + lowercase.pick(8) + uppercase.pick(3)+ numbers.pick(3) ).shuffle();
                this.form.password = retVal;
                this.form.password_confirmation = retVal;
                return false;
            },
            togglePassword(){
                const togglePassword = document.querySelector('#togglePassword');
                const password = document.querySelector('#password');
                const cpassword = document.querySelector('#password_confirmation');
                const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
                password.setAttribute('type', type);
                cpassword.setAttribute('type', type);
                // toggle the eye / eye slash icon
                togglePassword.classList.toggle('fa-eye-slash');
            }
        },
        mounted() {
            this.$Progress.start();
			this.can('crud_super_admin').then(result => {
                this.crud_super_admin = result.crud_super_admin;
            }).then(result => {
                if(this.crud_super_admin == true){
					this.getAddSuperAdminData();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        }
    }
</script>